<div class="modal-overlay fixed inset-0 w-full min-h-full flex items-start md:items-center justify-center p-3 md:p-8 z-[1000] overflow-y-auto" id="modal">
    <div class="modal__window relative bg-white border border-[#e8edf3] rounded-2xl shadow-[0_24px_60px_rgba(40,56,66,0.30),0_8px_24px_rgba(40,56,66,0.18)] w-full max-w-[900px] max-h-[95vh] overflow-hidden flex flex-col animation-[modalIn_0.25s_ease-out]">

        <div class="flex flex-col flex-1 overflow-hidden">

            <section class="flex items-center justify-between px-5 py-2.5 bg-gradient-to-b from-[#f8fbff] to-white border-b border-[#e8edf3] rounded-t-2xl shrink-0">
                <h2 class="text-base font-medium text-corporate-3 m-0 tracking-wide truncate flex-1 mr-3">Buscar evento</h2>
                <div class="flex items-center gap-2 shrink-0">
                    <a (click)='closeEvent($event)' class="modal-close-btn inline-flex items-center justify-center w-9 h-9 rounded-full text-[#5a6b7a] bg-transparent border-none cursor-pointer transition-all duration-200 hover:bg-hover-2 hover:text-corporate hover:rotate-90">
                        <lucide-icon name="x" [size]="22"></lucide-icon>
                    </a>
                </div>
            </section>

            <div class="modal-body flex-1 overflow-y-auto" style="min-height: 420px;">

                <section class="px-5 py-3 mb-0">
                    <h3 class="text-[15px] font-medium text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                        <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                            <lucide-icon name="search" [size]="15"></lucide-icon>
                        </span>
                        Criterios de búsqueda
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Desde</label>
                            <div class="relative inline-block">
                                <input name="dateFrom" tabindex="2" type="hidden" class="flatpickr-input">
                                <input id="select-dateFrom" (click)="setActive(true,false)" class="flatpickr-input w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-colors duration-200 outline-none focus:border-corporate" placeholder="{{this.dateFrom}}" tabindex="2" type="text">
                                <div *ngIf="isActiveFrom" class="absolute z-[1100] block" id="dateFrom-picker">
                                    <app-date-picker (dateSelected)="clickDateSelected($event)"></app-date-picker>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Hasta</label>
                            <div class="relative inline-block">
                                <input name="dateTo" tabindex="4" type="hidden" class="flatpickr-input dateto">
                                <input id="select-dateTo" (click)="setActive(false, true)" class="flatpickr-input w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-colors duration-200 outline-none focus:border-corporate" placeholder="{{this.dateTo}}" tabindex="4" type="text">
                                <div *ngIf="isActiveTo" class="absolute z-[1100] block" id="dateTo-picker">
                                    <app-date-picker (dateSelected)="clickDateSelected($event)"></app-date-picker>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Buscar por nombre, matrícula</label>
                            <div class="flex items-center gap-1.5">
                                <input class="flex-1 min-w-0 px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-colors duration-200 outline-none focus:border-corporate" type="text" [(ngModel)]="searchText" name="search" autocomplete="off" placeholder="Buscar..." (keyup.enter)="onKey(searchText)">
                                <button class="inline-flex items-center justify-center h-8 px-3 rounded-lg text-xs font-medium text-white bg-save-btn cursor-pointer transition-all duration-200 hover:brightness-105" (click)="searchEvent($event)" type="submit">
                                    <lucide-icon name="search" [size]="14"></lucide-icon>
                                </button>
                                <button *ngIf="searchText" class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-[#5a6b7a] border border-[#d4dde6] bg-transparent cursor-pointer transition-all duration-200 hover:bg-hover-2 hover:border-corporate hover:text-corporate shrink-0" (click)="clearEvents($event)">
                                    <lucide-icon name="x" [size]="14"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="error" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{msg}}</span>
                    </div>
                </section>

                <section class="bg-[#f8fbff] px-5 py-3 mb-0 flex-1 overflow-y-auto">
                    <h3 class="text-[15px] font-medium text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                        <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                            <lucide-icon name="list" [size]="15"></lucide-icon>
                        </span>
                        Resultados
                    </h3>

                    <div *ngIf="loading" class="flex justify-center items-center py-8">
                        <mat-spinner [diameter]="25"></mat-spinner>
                    </div>

                    <div *ngIf="events.length==0 && !loading && !error" class="flex flex-col items-center justify-center py-8 text-[#9aa8b5]">
                        <lucide-icon name="inbox" [size]="32"></lucide-icon>
                        <p class="text-sm m-0 mt-2">{{msg}}</p>
                    </div>

                    <div *ngFor="let item of events" class="bg-white border border-[#e8edf3] rounded-xl p-3 mb-2 transition-colors duration-200 hover:border-corporate">
                        <div class="flex items-center justify-between gap-3 flex-wrap">
                            <div class="flex items-center gap-3 flex-1 min-w-0">
                                <div class="flex flex-col items-center justify-center w-12 h-12 rounded-lg bg-[#f0f4f8] shrink-0">
                                    <span class="text-[10px] text-[#9aa8b5] uppercase tracking-wide">{{item.dateFrom | slice:3:5}}</span>
                                    <span class="text-[18px] font-medium text-corporate-3 leading-tight">{{item.dateFrom | slice:0:2}}</span>
                                </div>
                                <div class="flex flex-col min-w-0">
                                    <span class="text-[14px] font-medium text-corporate-3 truncate">{{item.title}}</span>
                                    <span class="text-[12px] text-[#9aa8b5]">{{item.dateFrom}} &middot; {{item.timeFrom}}</span>
                                </div>
                            </div>
                            <div class="flex items-center gap-2 shrink-0">
                                <button class="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-xs font-medium text-corporate-3 bg-[#eef3f9] border-none cursor-pointer transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate" (click)="goToModalEditEvent($event, item)">
                                    <lucide-icon name="pencil" [size]="14"></lucide-icon>
                                    <span>Modificar</span>
                                </button>
                                <button class="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-xs font-medium text-corporate-3 bg-[#eef3f9] border-none cursor-pointer transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate" (click)="goToCalendar($event, item.dateFrom)">
                                    <lucide-icon name="calendar" [size]="14"></lucide-icon>
                                    <span>Ir a</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

        </div>
    </div>
</div>